import {EnumPricingItemType} from "./pricing-item-type";

export abstract class PricingItem {

    public id?: string;
    public family?: string;
    public isSelected?: boolean;
    public isValid?: boolean;
    public userInputs?: Record<string, any>;
    public prefilledInputs?: any;
    public pricingItemType?: EnumPricingItemType.CONSUMABLE | EnumPricingItemType.DEVICE | EnumPricingItemType.DEVICE_CONSUMABLE | EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP | EnumPricingItemType.PACK | EnumPricingItemType.OPTION;
    public isCmc?: boolean;
    public totalAppliedPrice?: string;

}
